




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import {
  buildKandidatPenunjang,
  formatPenunjang,
  KandidatPenunjang
} from "@/utils/klaimRehabMedik";

@Component
export default class DialogPilihPenunjang extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop() readonly register!: string | number;

  loading = false;
  kandidat: KandidatPenunjang[] = [];
  terpilih: string[] = [];

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.terpilih = [];
      this.muat();
    }
  }

  async muat() {
    const reg = this.register;
    if (!reg || this.loading) return;

    this.loading = true;
    this.kandidat = [];

    try {
      const [lab, radiologi] = await Promise.all([
        HasilPenunjangSvc.getLabByRegister(reg).catch(() => null),
        HasilPenunjangSvc.getRadiologiByRegister(reg).catch(() => null)
      ]);

      if (String(reg) !== String(this.register)) return;

      this.kandidat = buildKandidatPenunjang(
        (lab && lab.data) || [],
        (radiologi && radiologi.data) || []
      );
    } finally {
      this.loading = false;
    }
  }

  tempel() {
    const dipilih = this.kandidat.filter(
      item => this.terpilih.indexOf(item.key) !== -1
    );

    this.$emit("apply", formatPenunjang(dipilih));
    this.tutup();
  }

  tutup() {
    this.$emit("input", false);
  }
}
